import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeader from "../components/ui/SectionHeader";
import { LoadingTableRows } from "../components/ui/LoadingPlaceholder";
import { fetchPricing } from "../services/publicApi";

function PricingPage() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState({ type: "loading", message: "" });

  useEffect(() => {
    let mounted = true;

    async function loadPricing() {
      setStatus({ type: "loading", message: "" });
      try {
        const response = await fetchPricing();
        if (!mounted) return;
        setItems(response?.items || []);
        setStatus({ type: "idle", message: "" });
      } catch (error) {
        if (!mounted) return;
        setStatus({ type: "error", message: "Cenik se ted nepodarilo nacist z databaze." });
      }
    }

    loadPricing();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Ceník" title="Orientační ceny">
          Finální cena záleží na rozsahu, přístupu k trásam a materiálu. Cílem je mít základní představu před nabídkou.
        </SectionHeader>

        {status.message && (
          <div className="mt-6 rounded-md border border-cyan-300/20 bg-cyan-300/10 p-4 text-sm text-cyan-100">
            {status.message}
          </div>
        )}

        <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_360px]">
          <div className="card overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[620px] text-left text-sm">
                <thead className="bg-cyan-300/5 text-xs uppercase tracking-wide text-slate-400">
                  <tr>
                    <th className="px-5 py-3">Položka</th>
                    <th className="px-5 py-3">Cena</th>
                    <th className="px-5 py-3">Poznámka</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-cyan-300/10">
                  {status.type === "loading" && !items.length ? <LoadingTableRows rows={5} columns={3} /> : items.map((item) => (
                    <tr key={item.id || item.title}>
                      <td className="px-5 py-4 font-medium text-slate-200">{item.title}</td>
                      <td className="px-5 py-4 font-semibold text-white">{item.priceLabel}</td>
                      <td className="px-5 py-4 text-slate-400">{item.note || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {status.type !== "loading" && !items.length && status.type !== "error" && (
                <p className="p-5 text-sm text-slate-400">V databazi zatim nejsou zadne polozky ceniku.</p>
              )}
            </div>
          </div>

          <aside className="card p-6">
            <h2 className="text-xl font-bold text-white">Jak se cena potvrzuje</h2>
            <p className="mt-4 text-sm leading-6 text-slate-300">
              Po poptávce přijde krátká konzultace, případně prohlídka. Pak vznikne nabídka s jasným rozsahem.
            </p>
            <Link to="/kontakt" className="mt-6 btn-primary w-full">
              Poptat cenu
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default PricingPage;
